import { httpsFile, https } from "./http";

export function show(data){
    return https().get(`barcode-search/${data}`);
}